import styled, { css } from 'styled-components'

import { BadgeStyled } from './BadgeStyled'

export interface IWithBadgeStyled {
  /**
   * Badge placement relative to the child element.
   */
  placement?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left'
  /**
   * Vertical offset for the badge position.
   * Accepts a number (interpreted as px) or a CSS length string (e.g., '1rem', '8px').
   */
  verticalOffset?: number | string
  /**
   * Horizontal offset for the badge position.
   * Accepts a number (interpreted as px) or a CSS length string (e.g., '1rem', '8px').
   */
  horizontalOffset?: number | string
}

const getBadgeAnchor = ({
  placement = 'top-right',
  verticalOffset = 2,
  horizontalOffset = 2,
}: IWithBadgeStyled) => {
  const [vertical, horizontal] = placement.split('-') as [
    'top' | 'bottom',
    'left' | 'right',
  ]
  const vOffset =
    typeof verticalOffset === 'number' ? `${verticalOffset}px` : verticalOffset
  const hOffset =
    typeof horizontalOffset === 'number'
      ? `${horizontalOffset}px`
      : horizontalOffset

  return css`
    ${vertical}: ${vOffset};
    ${horizontal}: ${hOffset};
    transform: translate(
      ${horizontal === 'right' ? '50%' : '-50%'},
      ${vertical === 'bottom' ? '50%' : '-50%'}
    );
  `
}

export const WithBadgeStyled = styled.div<IWithBadgeStyled>`
  display: inline-block;
  position: relative;

  ${BadgeStyled} {
    position: absolute;
    ${(props) => getBadgeAnchor(props)}
    z-index: 1;
  }
`
